<template>
  <div v-if="parentId">
    <div class="home-panel-wrapper">
      <div class="PrivatePlotComponrnrtList-head">
        <!--              头部页面-->
        <div class="container-head">
          <div class="container-head-title" style="text-align: left">
            <i
              class="title-icon iconfont"
              :class="icon1"
              :style="{ color: changeColor }"
            ></i>
            <span class="title-text"
              ><b>{{ title1 }}</b></span
            >
            <common-button
              style="float: right"
              size="default"
              type="cancel"
              image
              @click="back"
              >返回</common-button
            >
          </div>
        </div>
        <div class="PasswordBoxList-list-body-main-fastener"></div>
      </div>
      <!--        内容-->
      <div class="PrivatePlotComponrnrtList-Subbody">
        <div class="container-private-Subbody-list">
          <div class="private-plot-panel-Sublist">
            <el-row :gutter="20" style="margin-top: 20px;padding-top: 20px">
              <div v-for="(item, index) in list1" :key="index">
                <el-col :span="submenuSpan">
                  <span
                    id="Sublabal"
                    class="detail-attachment-item"
                    @click="showSublabalInfo('labal', item)"
                    :style="`background-color:${changeColor[index % 10]}`"
                    style=" box-shadow: #FC697D 0 1px 10px;"
                  >
                    <i class="private-item-more el-icon-more"></i>
                    <i class="private-item-right el-icon-arrow-right"></i>
                    <div
                      class="private-Subitem-in-up iconfont"
                      :class="item.icon"
                      :style="`color:${changeColor[index % 10]}`"
                    ></div>
                    <div class="private-Subitem-in-down" prop="name">
                      <b> {{ item.name }} </b>
                    </div>
                  </span>
                </el-col>
              </div>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <animation
      :loadingDataVisible="isLoading"
      loadingText="loading"
    ></animation>
  </div>

  <div v-else>
    <div class="home-panel-wrapper">
      <div class="PrivatePlotComponrnrtList-head">
        <el-container>
          <el-header>
            <span
              class="PrivatePlotComponrnrtList-tabel"
              style="text-align: left;float: left;"
              >个人信息</span
            >
          </el-header>
          <el-container>
            <el-aside width="200px">
              <el-avatar
                shape="square"
                style="margin: 20px;background-color: white;"
                :size="150"
                :src="avatar"
              >
              </el-avatar>
            </el-aside>
            <el-main>
              <el-row style="margin-top: 20px">
                <el-col style="margin-bottom: 15px">
                  <div
                    class="card-inviter"
                    style="font-size: 18px;margin-top: 10px"
                  >
                    <b class="PrivatePlotComponrnrtList-name">
                      <span v-if="UserName">{{ UserName }}</span>
                      <span v-else>无</span>
                    </b>
                  </div>
                  <!--         <span class="PrivatePlotComponrnrtList-name">姓名</span><br>-->
                </el-col>
                <el-col>
                  <div
                    class="PrivatePlotComponrnrtList-phone"
                    style="font-size: 18px;margin-top: 10px"
                  >
                    <span v-if="phone"
                      >手机号：{{
                        phone
                          ? phone.replace(/(\d{4})\d*(\d{0})/, "$1*******$2")
                          : ""
                      }}</span
                    >
                    <span v-else>手机号：无</span>
                  </div>
                  <!--          <span class="PrivatePlotComponrnrtList-phone" >手机号</span><br>-->
                </el-col>
                <el-col>
                  <div
                    class="PrivatePlotComponrnrtList-organ"
                    style="font-size: 18px;margin-top: 10px;float: left"
                  >
                    <b>
                      <span v-if="orgName">机构:{{ orgName }}</span>
                      <span v-else>机构：无</span>
                    </b>
                  </div>
                  <div v-if="title" class="grid-content bg-purple">
                    <span class="text-title">{{ title }}</span>
                  </div>
                  <div v-if="tutor" class="grid-content bg-purple">
                    <span class="text-title">{{ tutor }}</span>
                  </div>
                  <div v-if="directionLv1" class="grid-content bg-purple">
                    <span class="text-title">{{ directionLv1 }}</span>
                  </div>
                  <div v-if="directionLv2" class="grid-content bg-purple">
                    <span class="text-title">{{ directionLv2 }}</span>
                  </div>
                  <common-button
                    style="float: right"
                    size="default"
                    type="cancel"
                    image
                    @click="back"
                    >返回</common-button
                  >
                </el-col>
              </el-row>
            </el-main>
          </el-container>
        </el-container>
      </div>
      <div class="PrivatePlotComponrnrtList-body">
        <div class="container-private-body-list">
          <div class="private-plot-panel-list">
            <el-row :gutter="20" style="margin-top: 20px">
              <div v-for="(item, index) in list" :key="index">
                <el-col :span="menuSpan">
                  <span
                    :label="item.parentId"
                    id="labal"
                    :style="`background-color:${changeColor[index % 10]}`"
                    style="box-shadow: rgb(97, 159, 240) 0 1px 10px;"
                    @click="showlabal('labal', item)"
                  >
                    <div
                      class="private-item-in-up iconfont"
                      :class="item.icon"
                      style="color: #fef8f1;font-size: 140px;"
                    ></div>
                    <div
                      class="private-item-in-down-icon  iconfont"
                      :class="item.icon"
                      style="color: #fef8f1;font-size: 140px;opacity: 20%; "
                    ></div>
                    <div class="private-item-in-down">{{ item.name }}</div>
                    <div class="private-item-in-down-text">
                      {{ item.subTitle }}
                    </div>
                  </span>
                </el-col>
              </div>
            </el-row>
          </div>
          <div class="private-item-down"></div>
        </div>
      </div>
    </div>
    <animation
      :loadingDataVisible="isLoading"
      loadingText="loading"
    ></animation>
  </div>
</template>
<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import animation from "@/components/loading/animation";
import { generateStandardSpan } from "@/utils/acquireStandardSpan";
export default {
  name: "PrivatePlotList",
  components: { animation },
  data() {
    return {
      data: [],
      this_: this, //保存this以便filters中使用
      //灵敏度
      menuSensitive: 400,
      SubmenuSensitive: 340,
      //个人信息默认span
      submenuSpan: 6,
      //子页面默认span
      menuSpan: 8,
      isLoading: false,
      loadingText: null,
      imgurl: "",
      input: "",
      userphone: "",
      UserName: "",
      orgName: "",
      User: "",
      title: "",
      title1: "",
      tutor: "",
      directionLv1: "",
      directionLv2: "",
      phone: "",
      avatar: "",
      query: "",
      name: "",
      name01: "",
      subTitle: "",
      icon1: "",
      parentId: "",
      list: [],
      list1: [],
      changeColor: [
        "#fbaf57",
        "#55a7f4",
        "#ff526e",
        "#5ed985",
        "#7772ec",
        "#5ed5d9",
        "#1e90ff",
        "#a29bfe",
        "#be2edd",
        "#3742fa"
      ]
    };
  },
  created() {
    this.getQuery();
  },
  mounted() {
    this.initPage();
    this.getAllLabel();
  },
  //销毁时销毁监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.windowSizeChange);
  },
  watch: {
    $route(to, from) {
      //监听URL地址栏参数变化
      this.query = this.$route.query;
      this.parentId = this.query.parentId;
    }
  },
  methods: {
    getAllLabel() {
      this.isLoading = true;
      if (this.parentId) {
        this.getSubLabel();
        this.getTitle();
        return;
      } else {
        this.getPrivateInfo();
        this.getLabel();
        return;
      }
    },

    //抓取页面的parentId
    getQuery() {
      this.query = this.$route.query;
      this.parentId = this.query.parentId;
      this.isLoading = true;
    },

    //显示查看全部标签
    getLabel() {
      // this.isLoading = true;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu", {
          token: token,
          data: {}
        })
        .then(response => {
          let responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
              this.list = responseDate.data.eimsZldMenuList;
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    //个人信息
    getPrivateInfo() {
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/user/share/userInfo", {
          token: token,
          data: {}
        })
        .then(response => {
          let responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
              this.UserName = responseDate.data.userShare.name;
              this.orgName = responseDate.data.userShare.departmentName;
              this.phone = responseDate.data.userShare.userId;
              this.avatar =
                window.config.avatar.baseUrl +
                "/" +
                responseDate.data.userShare.avatar;
              this.title = responseDate.data.userShare.title;
              this.tutor = responseDate.data.userShare.tutor;
              this.directionLv1 = responseDate.data.userShare.directionLv1;
              this.directionLv2 = responseDate.data.userShare.directionLv2;
            }
          }
        });
    },
    //点击展开页面
    showSublabalInfo(id, item) {
      this.isLoading = true;
      this.$router
        .push({
          path: "/privateplot/PaperList",
          query: { parentId: item.parentId, zldMenuId: item.id }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    showlabal(id, item) {
      this.isLoading = true;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/main", {
          token: token,
          data: {
            parentId: item.id + ""
          }
        })
        .then(response => {
          let responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
              const res = responseDate.data.eimsZldMenuList;
              this.$router.push({
                path: "/privateplot/PaperList",
                query: { parentId: item.id, zldMenuId: res[0].id }
              });
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    back() {
      this.$router.push({ path: "/home" });
    },
    // 新建按钮
    openFile() {},
    importFile() {},
    download() {},
    //查询
    catchFilw() {
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/select", {
          token: token,
          data: {
            name: this.name01,
            parentId: this.parentId
          }
        })
        .then(response => {
          let responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
              this.list1 = responseDate.data.eimsZldMenuList;
            }
          }
        });
    },

    //显示子页面标题
    getTitle() {
      // this.isLoading = true;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/title", {
          token: token,
          data: {
            parentId: this.parentId
          }
        })
        .then(response => {
          let responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
              this.title1 = responseDate.data.title.name;
              this.icon1 = responseDate.data.title.icon;
              // this.list = responseDate.data.eimsZldMenuList;
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    //显示子标签
    getSubLabel() {
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/main", {
          token: token,
          data: {
            parentId: this.parentId
          }
        })
        .then(response => {
          let responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
              this.list1 = responseDate.data.eimsZldMenuList;
            }
          }
        });
    },
    // showScalingAnimation(id, obj) {
    //   let dom = document.getElementById(id)
    //   dom.setAttribute("class", "style_prevu_play")
    //   setTimeout(() => {
    //     dom.setAttribute("class", "style_prevu_stop")
    //     if (obj) {
    //       this.$router.push(obj)
    //     }
    //   }, 200)
    // },
    // //子页面
    // showScalingAnimationSub(id, obj) {
    //   let dom = document.getElementById(id)
    //   dom.setAttribute("class", "style_Subprevu_play")
    //   setTimeout(() => {
    //     dom.setAttribute("class", "style_Subprevu_stop")
    //     if (obj) {
    //       this.$router.push(obj)
    //     }
    //   }, 200)
    // },
    initPage() {
      window.addEventListener("resize", this.windowSizeChange, false);
      this.windowSizeChange();
    },
    timeOutChange() {
      let that = this;
      if (this.spanTimeout !== null) {
        clearTimeout(this.spanTimeout);
        this.spanTimeout = null;
      }

      this.spanTimeout = setTimeout(() => {
        that.windowSizeChange();
      }, 10);
    },
    //窗口发生变化
    windowSizeChange() {
      if (this.parentId) {
        let submenuPanel = document.getElementsByClassName(
          "private-plot-panel-Sublist"
        )[0];
        this.submenuSpan = generateStandardSpan(
          submenuPanel.offsetWidth,
          this.SubmenuSensitive
        );
      } else {
        let menuPanel = document.getElementsByClassName(
          "private-plot-panel-list"
        )[0];
        this.menuSpan = generateStandardSpan(
          menuPanel.offsetWidth,
          this.menuSensitive
        );
      }
    }
  }
};
</script>
<style scoped>
@import url("//unpkg.com/element-ui@2.15.10/lib/theme-chalk/index.css");
.home-panel-wrapper {
  /*margin-top: 20px;*/
  /*margin-left: 20px;*/
  /*margin-right: 20px;*/
  margin: 20px;
}
.PrivatePlotComponrnrtList-head {
  width: 100%;
  height: 100%;
  border-color: rgb(187, 187, 187);
  border-width: 0px;
  border-style: solid;
  border-radius: 10px;
  font-size: 14px;
  padding: 0px;
  text-align: center;
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  background: rgb(255, 255, 255);
}
.PrivatePlotComponrnrtList-body {
  width: 100%;
  height: 100%;
  /*margin: 10px;*/
  border-color: rgb(187, 187, 187);
  border-width: 0px;
  border-style: solid;
  border-radius: 10px;
  font-size: 14px;
  padding: 0px;
  text-align: center;
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  background: rgb(255, 255, 255);
}
.PrivatePlotComponrnrtList-tabel {
  font-family: SourceHanSansSC;
  font-weight: 700;
  font-size: 24px;
  color: rgba(8, 39, 44, 1);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
  margin-top: 30px;
  margin-left: 30px;
}
.container-private-body-list .private-plot-panel-list {
  text-align: center;
  background: transparent;
}
.container-private-body-list .private-plot-panel-list span {
  background-image: url("/static/images/private-item.png");
  padding: 20px;
  text-align: left;
  margin: 10px 10px;
  display: inline-block;
  width: 90%;
  height: 220px;
  border-radius: 10px;
  cursor: pointer;
}
.private-plot-panel-list > span {
  cursor: pointer;
}
.private-item-in-up:before {
  float: right;
  line-height: 1;
}
.private-item-in-down-icon {
  /*!*margin: 15px;*!*/
  /*right: 100px;*/
  /*position: absolute;*/
  /*bottom: 40px;*/
  /*margin-right: 7px;*/
  /*width: 40px;*/
  /*background-position: right bottom;*/
  /*height: 50px;*/
  /*!*position: absolute;*!*/
  /*!*background-position: right ;*!*/
  /*!*background-color: white;*!*/
  /*border-radius: 50px;*/
  width: 0;
  margin-top: 70px;
  margin-right: -5px;
  float: right;
}
.private-item-in-down-icon:after {
  line-height: 1;
}
.private-item-in-down {
  color: white;
  font-weight: bold;
  margin-top: 15%;
  /* overflow: hidden; */
  position: inherit;
  font-size: x-large;
}
.private-item-in-down-text {
  color: white;
  font-size: 25px;
  font-weight: bold;
  margin-top: 40px;
}
/*.icon-icon_yanjing1:before {*/
/*  font-size: 140px;*/
/*  color: #fef8f1;*/
/*}*/
/*.icon-icon_yanjing1-after:after {*/
/*  content: "\e767";*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*  opacity: 20%;*/
/*}*/
/*.icon-icon_danao2:before {*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*}*/
/*.icon-icon_danao2-after:after {*/
/*  color: #fef8f1;*/
/*  content: "\e76e";*/
/*  font-size: 140px;*/
/*  opacity: 20%;*/
/*}*/
/*.icon-footprint-full:before {*/
/*  font-size: 140px;*/
/*  color: #fef8f1;*/
/*}*/
/*.icon-footprint-full-after:after {*/
/*  content: "\e91b";*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*  opacity: 20%;*/
/*}*/
/*.icon-hezuo1:before {*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*}*/
/*.icon-hezuo1-after:after {*/
/*  content: "\e6f3";*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*  opacity: 20%;*/
/*}*/
/*.icon-icon_xiaolian:before {*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*}*/
/*.icon-icon_xiaolian-after:after {*/
/*  content: "\e76c";*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*  opacity: 20%;*/
/*!*}*!*/
/*.icon-taocan-suoxiao:before {*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*}*/
/*.icon-taocan-suoxiao-after:after {*/
/*  content: "\e8cd";*/
/*  color: #fef8f1;*/
/*  font-size: 140px;*/
/*  opacity: 20%;*/
/*}*/
.style_prevu_stop {
  display: inline-block;
  text-align: left;
  border: 0;
  width: 100px;
  height: 210px;
  position: relative;
  -webkit-transition: all 200ms ease-in;
  -webkit-transform: scale(1);
  -ms-transition: all 200ms ease-in;
  -ms-transform: scale(1);
  -moz-transition: all 200ms ease-in;
  -moz-transform: scale(1);
  transition: all 200ms ease-in;
  transform: scale(1);
}
.style_prevu_play {
  animation-duration: 200ms;
  animation-name: transformBig;
  animation-fill-mode: forwards;
  top: calc(50vh - 120px);
  left: calc(50vw - 230px);
  position: fixed;
  box-shadow: 0px 0px 150px #000000;
  -webkit-transition: all 200ms ease-in;
  -webkit-transform: scale(5);
  -ms-transition: all 200ms ease-in;
  -ms-transform: scale(5);
  -moz-transition: all 200ms ease-in;
  -moz-transform: scale(5);
  transition: all 200ms ease-in;
  transform: scale(5);
}
@keyframes transformBig {
  50% {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
}
/*#myInfo {*/
/*  box-shadow: rgb(252, 131, 97) 0 1px 10px;*/
/*  background-color: rgb(252, 131, 97)*/
/*}*/
/*#password-safe-box {*/
/*  box-shadow: rgb(97, 159, 240) 0 1px 10px;*/
/*  !*background-color: rgb(97, 159, 240)*!*/
/*}*/
/*#certificate {*/
/*  box-shadow: rgb(252, 108, 128) 0 1px 10px;*/
/*  background-color: rgb(252, 108, 128)*/
/*}*/
/*#photos {*/
/*  box-shadow: rgb(125, 115, 230) 0 1px 10px;*/
/*  background-color: rgb(125, 115, 230)*/
/*}*/
/*#activity {*/
/*  box-shadow: rgb(29, 221, 161) 0 1px 10px;*/
/*  background-color: rgb(29, 221, 161)*/
/*}*/
/*#library {*/
/*  box-shadow: rgb(118, 211, 241) 0 1px 10px;*/
/*  background-color: rgb(118, 211, 241)*/
/*}*/
/*#labelStyle {*/
/*  box-shadow: rgb(250, 178, 85) 0 1px 10px;*/
/*  !*background-color: var(moveColor);*!*/
/*}*/
.PrivatePlotComponrnrtList-name {
  font-family: SourceHanSansSC;
  font-weight: 700;
  float: left;
  font-size: 18px;
  color: rgba(8, 39, 44, 1);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
}
.PrivatePlotComponrnrtList-phone {
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 16px;
  float: left;
  margin-top: 5px;
  color: rgba(8, 39, 44, 1);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 26px;
  text-decoration: none;
}
.PrivatePlotComponrnrtList-organ {
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(8, 39, 44, 1);
  margin-top: 5px;
  font-style: normal;
  float: left;
  letter-spacing: 0px;
  line-height: 26px;
  text-decoration: none;
}
/*.PrivatePlotComponrnrtList-list-body-button{*/
/*  !*border: 1px solid #3ec4db;*!*/
/*  border-radius: 3px;*/
/*  width: 80px;*/
/*  height: 40px;*/
/*  text-align: center;*/
/*  background-image: url(/static/images/fourbackground.png);*/
/*  color: rgb(140 147 250);*/
/*  border: 1px solid  #7ac1fc;*/
/*  font-weight: bold;*/
/*  float: right;*/
/*  outline: none;*/
/*  background-color: #ffffff;*/
/*}*/
.bg-purple {
  background: #ccf0f9;
  color: #34c5e7;
}
.grid-content {
  min-height: 36px;
  border-radius: 50px;
  line-height: 3;
  width: auto;
  margin-top: 1px;
  margin-left: 20px;
  float: left;
}
.text-title {
  margin: 20px;
}

/*子页面*/

.PasswordBoxList-list-body-main-fastener {
  padding: 10px;
}
.PasswordBoxList-list-body-main-button {
  border: none;
  color: rgb(241 247 255);
  outline: none;
  border-radius: 3px;
  width: 120px;
  height: 35px;
  text-align: center;
  background-image: url("/static/images/fourbackground.png");
}
.PasswordBoxList-list-body-main-button:hover {
  background-color: #3a8ee6;
  color: white;
}
.PasswordBoxList-list-body-main-button-down {
  border: none;
  color: rgb(241 247 255);
  outline: none;
  border-radius: 3px;
  width: 85px;
  height: 35px;
  text-align: center;
  background-image: url(/static/images/fourbackground.png);
}
PasswordBoxList-list-body-main-button:hover {
  background-color: rgb(214 216 220);
  color: rgb(241 247 255);
}
.pending-items-search input {
  width: 330px;
  margin-left: 10px;
  height: 35px;
}
.input-catch {
  -webkit-appearance: none;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  /* height: 40px; */
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
i.icon-sousuo {
  margin-left: -35px;
  color: #d3d4d5;
}

/*内容*/
.PrivatePlotComponrnrtList-Subbody {
  width: 100%;
  height: 100%;
  /*margin: 10px;*/
  border-color: rgb(187, 187, 187);
  border-width: 0px;
  border-style: solid;
  border-radius: 10px;
  font-size: 14px;
  padding: 0px;
  text-align: center;
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  background: rgb(255, 255, 255);
}
.container-private-Subbody-list .private-plot-panel-Sublist {
  text-align: center;
  background: transparent;
}

/*.container-private-Subbody-list .private-plot-panel-Sublist span {*/
/*  background-image: url('/static/images/private-item.png');*/
/*  padding: 20px;*/
/*  text-align: left;*/
/*  margin: 10px 10px;*/
/*  display: inline-block;*/
/*  !*position: inherit;*!*/
/*  width: 90%;*/
/*  height: 147px;*/
/*  border-radius: 10px;*/
/*  font-size: 40px;*/
/*}*/
.detail-attachment-item {
  background-image: url("/static/images/private-item.png");
  padding: 27px 20px 20px 20px;
  text-align: left;
  cursor: pointer;
  margin: 10px 10px;
  display: inline-block;
  /*position: inherit;*/
  width: 90%;
  height: 147px;
  border-radius: 10px;
}
.detail-attachment-item:hover {
  box-shadow: 0px 0px 20px #b1b0b0;
  transition: all 300ms;
}
.private-plot-panel-Sublist > span {
  cursor: pointer;
}
.style_Subprevu_stop {
  display: inline-block;
  text-align: left;
  border: 0;
  width: 290px;
  height: 147px;
  position: relative;
  -webkit-transition: all 200ms ease-in;
  -webkit-transform: scale(1);
  -ms-transition: all 200ms ease-in;
  -ms-transform: scale(1);
  -moz-transition: all 200ms ease-in;
  -moz-transform: scale(1);
  transition: all 200ms ease-in;
  transform: scale(1);
}

.style_Subprevu_play {
  animation-duration: 200ms;
  animation-name: transformBig;
  animation-fill-mode: forwards;
  top: calc(50vh - 73px);
  left: calc(50vw - 145px);
  position: fixed;
  box-shadow: 0px 0px 150px #000000;
  -webkit-transition: all 200ms ease-in;
  -webkit-transform: scale(3);
  -ms-transition: all 200ms ease-in;
  -ms-transform: scale(3);
  -moz-transition: all 200ms ease-in;
  -moz-transform: scale(3);
  transition: all 200ms ease-in;
  transform: scale(3);
}
/*@keyframes transformBig {*/
/*  50%{*/
/*    opacity: 1;*/
/*  }*/
/*  to{*/
/*    opacity: .5;*/
/*  }*/
/*}*/
.private-item-more {
  font-weight: bold;
  float: right;
}
.private-item-right {
  font-weight: bold;
  float: right;
  margin-top: 30px;
  margin-right: -20px;
  overflow: hidden;
  position: initial;
}
.el-icon-arrow-right:before {
  content: "\e6e0";
  color: white;
  font-size: 25px;
}
.el-icon-more:before {
  content: "\e794";
  color: white;
  font-size: 25px;
}
.private-Subitem-in-up {
  /* margin: 15px; */
  /* margin-left: -90px; */
  /* left: 30px; */
  line-height: 7;
  /* height: 40px; */
  margin-right: 10px;
  /* width: 3px; */
  background-position: right bottom;
  height: 80px;
  position: absolute;
  background-position: right;
  background-color: white;
  border-radius: 100%;
}
.private-Subitem-in-up:before {
  line-height: 1px;
  font-size: 60px;
  margin: 10px;
}

.private-Subitem-in-down {
  /* width: 140px; */
  /* color: white; */
  /* font-weight: bold; */
  /* margin-top: -40px; */
  /* font-size: 32px; */
  margin-left: 35%;
  /* line-height: 0px; */
  font-family: SourceHanSansSC;
  /* font-weight: 500; */
  font-size: 27px;
  margin-top: 20px;
  color: white;
  font-style: normal;
  letter-spacing: 0px;
  line-height: 35px;
  text-decoration: none;
}
.title-icon {
  font-size: 29px;
  margin: auto;
  color: rgb(97, 159, 240);
  margin-top: 13px;
  position: absolute;
}
.title-text {
  font-size: 15px;
  position: absolute;
  float: left;
  margin: 13px 31px;
}
.menu-panel {
}
</style>



// WEBPACK FOOTER //
// src/pages/privateplot/PrivatePlotList.vue